/** @jsx jsx */
import { jsx } from 'theme-ui';
import GridImage from './GridImage';
import { Box } from '@bottlebooks/gatsby-design-system';
import { graphql } from 'gatsby';

export default function ImageBlock({ image, width }) {
  return (
    <Box>
      <GridImage
        image={image}
        sx={{ width: '100%' }}
        width={width}
        alt={'Image'}
      />
    </Box>
  );
}

export const fragment = graphql`
  fragment SanityImageBlockFragment on SanityImageBlock {
    image {
      ...ImageWithPreview
    }
  }
`;
